import { render } from "./sidebar-collapse-icon.vue.js?vue&type=template&id=11b0f806!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./sidebar-collapse-icon.vue?vue&type=template&id=11b0f806"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__